import React from "react";
import PropTypes from "prop-types";

function MediaItemgid({ gid }) {
  return <div>MediaItem: {JSON.stringify(gid)}</div>;
}

MediaItemgid.propTypes = {
  gid: PropTypes.string.isRequired,
};

export default MediaItemgid;
